<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :max="5" exclude="CreateClass">
        <router-view :key="key"/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    }
  }
};
</script>

<style lang="less" scoped>
.app-main {
  /* 50= navbar  50  */
  width: 100%;
  position: relative;
  overflow: auto;
}

.fixed-header + .app-main {
  top: @navBarTopHeight + @navBarTagsHeight;
  height: calc(100vh - (@navBarTopHeight + @navBarTagsHeight));
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - (@navBarTopHeight + @navBarTagsHeight));
  }

  .fixed-header + .app-main {
    top: @navBarTopHeight + @navBarTagsHeight;
    height: calc(100vh - (@navBarTopHeight + @navBarTagsHeight));
  }
}
</style>
